<template>
  <div>
    <div class="topbar">
      <div class="clearfix main-wrap">
        <a class="pull-left img-back" href="javascript:window.history.go(-1)">返回</a>
        <h1>{{info.className}}</h1>
        <span class="pull-right icon-right orange" @click="editClass()">保存</span>
      </div>
      <div class="liner"></div>
    </div>

    <div class="main-page class-edit">
      <div>
        <ul class="list-group-item tinny groups">
        <li class="list-group">
            <div class="liner"></div>
            <span class="clearfix group-txt">
              <span class="pull-left group-name">群名</span>
              <input class="pull-right text-right font-14" type="text" v-bind:placeholder="info.className" v-model="info.className" style="height:40px;line-height:40px;">
            </span>
          </li>
          <li class="list-group" @click="showSelectTeacher()">
            <div class="liner"></div>
            <a class="clearfix  group-txt img-more" href="javascript:;">
              <span class="pull-left group-teacher">老师</span>
              <span class="pull-right gray margin-x-15">
                <template v-for="item in teacherSelectList">
                  {{item.teacherName}}&nbsp;
                </template>
              </span>
            </a>
          </li>
          <li class="list-group" @click="showSelectStudent()">
            <div class="liner"></div>
            <a class="clearfix group-txt img-more" href="javascript:;">
              <span class="pull-left group-student">学生</span>
              <span class="pull-right gray margin-x-15">{{studentSelectList.length}}人</span>
            </a>
          </li>
        </ul>

        <ul class="list-group-item primary">
          <li class="list-group" v-for="item in studentSelectList">
            <div class="liner"></div>
            <router-link class="group-link clearfix"  :to="{path:'/student/detail/' + item.studentId}">
              <span class="img-wrap small pull-left">
              <img class="pull-left" :src="item.imageAddress ? item.baseAcessPath + item.imageAddress : img_default" width="40" height="40"/>
              </span>
              <span class="group-txt">
                <span class="block overhide">
                  <cite class="pull-left">{{item.studentName}}</cite>
                  <i class="img-sex boy" v-if="item.sex == '男'">男</i>
                  <i class="img-sex girl" v-if="item.sex == '女'">女</i>
                  <cite class="gray pull-right font-12" v-if="item.typeName">{{item.typeName}}</cite>
                  <cite class="orange pull-right font-12" v-else>未添加托管服务</cite>
                </span>
              </span>
            </router-link>
          </li>
        </ul>

        <ul class="list-group-item tinny">
          <li class="list-group">
            <span class="group-txt block text-center" @click="isHideDeleteClass = false">解散{{info.className}}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="maskdiv" v-show="!isHideGoAddStudent" @click="isHideGoAddStudent = true">
      <div class="popover" @click.stop>
        <div class="pop-wrap text-center">
          <p>该班级还没有录入过学生信息，是否现在去添加学生？</p>
          <div class="liner margin-15"></div>
          <div class="clearfix">
            <div class="col-xs-6 blue"><router-link class="blue  block" style="border-right:1px solid #ddd;" :to="{'path': '/student/add'}">去添加</router-link></div>
            <div class="col-xs-6 blue"><a class="blue" @click.prevent="isHideGoAddStudent = true">以后再说</a></div>
          </div>
        </div>
      </div>
    </div>

    <div class="maskdiv" v-show="!isHideDeleteClass" @click="isHideDeleteClass = true">
      <div class="popover" @click.stop>
        <div class="pop-wrap text-center">
          <p>您确定要解散这个群吗？</p>
          <div class="liner margin-15"></div>
          <div class="clearfix">
            <div class="col-xs-6 blue"><a class="blue  block" style="border-right:1px solid #ddd;" @click.prevent="deleteClassItem()">解散</a></div>
            <div class="col-xs-6 blue"><a class="blue" @click.prevent="isHideDeleteClass = true">不解散</a></div>
          </div>
        </div>
      </div>
    </div>

    <div class="maskdiv" v-show="!isHideSelectTeacher" @click="isHideSelectTeacher = true">
      <div class="slider" @click.stop>
        <strong class="tit">选择老师</strong>
        <div class="liner"></div>
        <div class="list-group-item tinny">
          <ul v-for="item in teacherList">
            <li @click.stop="item.isChecked = !item.isChecked">
              <div class="clearfix group-link"><span class="pull-left">{{item.teacherName}}</span>
                <i class="pull-right img-checkbox checked" v-if="item.isChecked"></i>
                <i class="pull-right img-checkbox" v-else></i>
              </div>
              <div class="liner"></div>
            </li>
          </ul>
        </div>
        <div class="text-center"><a class="button button-rounded button-line" @click.prevent="isHideSelectTeacher = true">确定</a></div>
      </div>
    </div>

    <!-- 选择学生 -->
    <dialogStudents :isHideSelectStudent="isHideSelectStudent" :studentFirstCharList="studentList" v-on:close="closeDialogStudents" v-on:selected="selectedStudent"></dialogStudents>
  </div>
</template>

<script>
import { service } from '../../service'
import { Toast } from 'mint-ui'
import { mapGetters, mapMutations } from 'vuex'
// component
import dialogStudents from '../../components/student/dialogStudents'

export default {
  data () {
    return {
      img_default: require('../../assets/images/img-default.png'),
      login_data: JSON.parse(window.localStorage['login_data']),
      cookie_login_data: JSON.parse(window.localStorage['basic_login_data']),
      find_new_class_info_para: service.setPara('findNewClassInfo'),
      delete_class_para: service.setPara('deleteClass'),
      edit_class_para: service.setPara('saveOrUpdateClass'),
      get_curche_teacher_para: service.setPara('getCurcheTeacher'),
      get_new_student_list_para: service.setPara('getNewStudentList'),
      info: {},
      isHideGoAddStudent: true,
      isHideDeleteClass: true,
      isHideSelectTeacher: true,
      isHideSelectStudent: true,
      curcheId: 0,
      studentIdList: [],
      studentList: [],
      teacherList: [],
      isGetTeacherList: false,
      isGetStudentList: false
    }
  },
  components: {
    dialogStudents
  },
  computed: {
    ...mapGetters({
      studentListX: 'getStudentsByFirstChar',
      teacherListX: 'teacherList'
    }),
    teacherSelectList: function () {
      let list = []
      for (let i = 0; i < this.teacherList.length; i++) {
        if (this.teacherList[i].isChecked) {
          list.push(this.teacherList[i])
        }
      }
      return list
    },
    studentSelectList: function () {
      let list = []
      for (let i = 0; i < this.studentList.length; i++) {
        if (this.studentList[i].students) {
          for (let j = 0; j < this.studentList[i].students.length; j++) {
            if (this.studentList[i].students[j].isChecked) {
              list.push(this.studentList[i].students[j])
            }
          }
        } else {
          if (this.studentList[i].isChecked) {
            list.push(this.studentList[i])
          }
        }
      }
      return list
    }
  },
  mounted: function () {
    this.classId = this.$route.params.classId
    this.curcheId = this.cookie_login_data.curcheId

    // 获取园点学生数据
    this.get_new_student_list_para.curcheId = this.curcheId
    this.get_new_student_list_para.sfzt = '在托'
    this.get_new_student_list_para.context = this
    this.$store.dispatch('receiveStudents', this.get_new_student_list_para)

    // 获取园点老师数据
    this.get_curche_teacher_para.curcheId = this.curcheId
    this.get_curche_teacher_para.context = this
    this.$store.dispatch('receiveTeachers', this.get_curche_teacher_para)

    // $('div.maskdiv,div.maskdiv div.slider').css('height', $(window).height())
    this.findNewClassInfo()
  },
  methods: {
    ...mapMutations([
      'receiveStudents',
      'receiveTeachers',
      'clearClass',
      'deleteClass'
    ]),
    // 查找班级信息
    findNewClassInfo: function () {
      this.find_new_class_info_para.classId = this.classId

      let that = this
      let obj = {context: this, para: this.find_new_class_info_para, successFun: (response) => {
        that.info = response.data
        for (let i = 0; i < that.info.teacherList.length; i++) {
          that.info.teacherList[i].isChecked = true
          that.teacherList.push(that.info.teacherList[i])
        }
        for (let j = 0; j < that.info.studentList.length; j++) {
          that.info.studentList[j].isChecked = true
          that.studentList.push(that.info.studentList[j])
        }
      }}
      service.request(obj)
    },
    // 删除班级
    deleteClassItem: function () {
      this.delete_class_para.classId = this.classId

      let obj = {context: this, para: this.delete_class_para, successFun: (response) => {
        Toast('删除成功')
        this.$store.dispatch('deleteClass', this.classId)
        window.history.go(-1)
      }}
      service.request(obj)
    },
    editClass: function () {
      if ($.trim(this.info.className) == '') {
        Toast('请填写群名称')
        return
      }

      if (this.studentSelectList.length == 0) {
        Toast('至少选择一位学生')
        return
      }

      this.edit_class_para.classImage = ''
      this.edit_class_para.classId = this.classId
      this.edit_class_para.className = this.info.className
      this.edit_class_para.curcheId = this.curcheId

      this.edit_class_para.teacherIdList = []
      for (let i = 0; i < this.teacherSelectList.length; i++) {
        this.edit_class_para.teacherIdList.push(this.teacherSelectList[i].teacherId)
      }

      this.edit_class_para.studentIdList = []
      for (let i = 0; i < this.studentSelectList.length; i++) {
        this.edit_class_para.studentIdList.push(this.studentSelectList[i].studentId)
      }

      let obj = {context: this, para: this.edit_class_para, successFun: (response) => {
        Toast('编辑成功')
        this.$store.dispatch('clearClass')
        window.history.go(-1)
      }}
      service.request(obj)
    },
    // 显示关联老师
    showSelectTeacher: function () {
      if (this.isGetTeacherList) { // 已经有关联老师数据
        this.isHideSelectTeacher = false
        return
      }

      let jsonStr = JSON.stringify(this.teacherListX)
      let list = JSON.parse(jsonStr)
      for (let i = 0; i < list.length; i++) {
        list[i].isChecked = false
        for (let j = 0; j < this.info.teacherList.length; j++) {
          if (this.info.teacherList[j].teacherId == list[i].teacherId) {
            list[i].isChecked = true
            break
          }
        }
      }
      this.teacherList = list
      this.isHideSelectTeacher = false
      this.isGetTeacherList = true
    },
    // 显示编入学生
    showSelectStudent: function () {
      if (this.isGetStudentList) { // 已经有关联学生数据
        this.isHideSelectStudent = false
        return
      }

      let jsonStr = JSON.stringify(this.studentListX)
      let list = JSON.parse(jsonStr)
      // for (let i = 0; i < list.length; i++) {
      //   list[i].isChecked = false
      //   for (let j = 0; j < this.info.studentList.length; j++) {
      //     if (this.info.studentList[j].studentId == list[i].studentId) {
      //       list[i].isChecked = true
      //       break
      //     }
      //   }
      // }

      for (let i = 0; i < list.length; i++) {
        for (let j = 0; j < list[i].students.length; j++) {
          list[i].students[j].isChecked = false
          for (let z = 0; z < this.info.studentList.length; z++) {
            if (this.info.studentList[z].studentId == list[i].students[j].studentId) {
              list[i].students[j].isChecked = true
              break
            }
          }
        }
      }

      this.studentList = list
      this.isGetStudentList = true

      var jobCode = this.login_data[this.cookie_login_data.index].jobCode
      var yesNo = this.login_data[this.cookie_login_data.index].yesNo
      if ((jobCode === 'leader' || jobCode === 'dudao') && yesNo === 1) {
        if (this.studentList.length === 0) {
          this.isHideGoAddStudent = false
        } else {
          this.isHideSelectStudent = false
        }
      }
    },
    closeDialogStudents () { // 关闭选择学生弹出框
      this.isHideSelectStudent = true
    },
    selectedStudent (student) {
      student.isChecked = !student.isChecked
    }
  }
}
</script>
<style scoped>
  .mint-indexlist-content{padding-right:32px;}
</style>



// WEBPACK FOOTER //
// ClassEdit.vue?00c4cc72